import React from "react";

type SectionHeaderProps = {
  title: string | React.ReactNode;
  subtitle?: string | React.ReactNode;
  buttonText?: string;
  buttonIcon?: React.ReactNode;
  onButtonClick?: () => void;
  buttonVariant?: string;
  children?: React.ReactNode;
  className?: string;
};

const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  subtitle,
  buttonText = "",
  buttonIcon,
  onButtonClick,
  buttonVariant = "outline-secondary",
  children,
  className = "",
}) => {
  return (
    <div
      className={`d-flex align-items-center justify-content-between mb-4 ${className}`}
    >
      <div>
        <h4 className="fw-semibold mb-1">{title}</h4>
        {subtitle && <p className="text-secondary small mb-0">{subtitle}</p>}
      </div>
      {(buttonText || children) && (
        <div className="d-flex align-items-center gap-2">
          {children}
          {buttonText && (
            <button
              className={`btn btn-sm btn-${buttonVariant} d-flex align-items-center gap-2`}
              onClick={onButtonClick}
            >
              {buttonIcon} {buttonText}
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default SectionHeader;
